import React from 'react'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import SettingsIcon from '@mui/icons-material/Settings'
import { ExtractAtomValue } from 'jotai'
import { issueTableDataAtom } from '../../atoms/issueAtom'

export type TableSettingHeaderProps<
    T extends keyof ExtractAtomValue<typeof issueTableDataAtom> = keyof ExtractAtomValue<typeof issueTableDataAtom>,
> = {
    header?: string | null
    onClick: (element: Element, v: T) => void
    setting: T
}

export const TableSettingHeader = ({ header, onClick, setting }: TableSettingHeaderProps) => (
    <Stack
        direction='row'
        spacing={1}
        sx={{
            alignItems: 'center',
        }}
    >
        <IconButton
            disableRipple
            onClick={(e) => {
                e.stopPropagation()
                onClick(e.currentTarget, setting)
            }}
            sx={{
                padding: 0,
            }}
        >
            <SettingsIcon fontSize='small' />
        </IconButton>
        <Typography
            sx={{
                fontWeight: 800,
            }}
        >
            {header}
        </Typography>
    </Stack>
)
